import {Base} from './Base'

export class InventoryType extends Base {

  resourceName() {
    return 'inventory_types'
  }

  fields() {
    return [
      'name',
      'is_deleted',
    ]
  }

}